import React from 'react';

class DebounceSCU extends React.Component {

  shouldComponentUpdate (nextProps:any) {
    return nextProps.shouldComponentUpdate;
  }

  render () {
    return (
      //@ts-ignore
      this.props.children
    );
  }
}

export default DebounceSCU;
